export default "__VITE_ASSET__7ba8d7cf__"